
export function bio_reg_check() {
  let param = {
    action: 'bio_reg_check',
    callback: 'appInterFace', //상태값을 받을 콜백함수명(상태값 리턴해줌)
  };
  //앱단으로 생체인증 등록여부 상태값 요청
  window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(param));
}

//인증상태값을 넘겨받을 함수
export function callback_fun_check(val) {
  //val(인증값) = 1:인증정보등록됨, 0:인증정보등록안됨
  alert(val); //넘어온 인증값 확인
}

export function bio_auth(renewal = false, value) {
  let param = {
    action: 'bio_auth',
    data: { key1: value }, //최초 생체인증 완료시 웹으로 전달될값지정( 필요없을시 data 변수삭제 : 앱단 디바이스 고유아이디값으로 기본 지정됨 )
    renewal: renewal, //생체인증 재등록(재인증시) true로 지정함. (위 data값으로 신규저장처리됨)
    callback: 'appInterFace', //상태값을 받을 콜백함수명(인증결과를 리턴해줌)
  };
  //앱단으로 생체인증 실행 요청
  window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(param));
}

//인증상태값을 넘겨받을 함수
export function callback_fun(val, data) {
  //val(인증값) = 1:인증성공,2:인증등록성공(안드로이드용),0:인증실패
  alert(val); //넘어온 인증값 확인
  alert(JSON.stringify(data)); //생체인증으로 저장된 값 확인(인증성공시에만 넘어옴)
  //인증값에 따른 로직을 아래에 적용해주시면됩니다.
  //안드로이드는 등록과정이 있기때문에 등록이후 인증되는 "1"값이 넘어올때가 최종인증으로 보면 됨.
}

// // 웹페이지 로딩 되자마자 자동으로 생체인증 기능 실행되려면
// export const bioAuth = (callback) => {
//   const param = {
//     action: 'bio_auth',
//     data: { key1: 'value1', key2: 'value2' }, //최초 생체인증 완료시 웹으로 전달될값지정( 필요없을시 data 변수삭제 : 앱단 디바이스 고유아이디값으로 기본 지정됨 )
//     renewal: false, //생체인증 재등록(재인증시) true로 지정함. (위 data값으로 신규저장처리됨)
//     callback: callback(), //상태값을 받을 콜백함수명(인증결과를 리턴해줌)
//   };
//   //앱단으로 생체인증 실행 요청
//   const re = window.parent.postMessage(JSON.stringify(param));
//   callback(re.val, re.data);
// };

// //인증상태값을 넘겨받을 함수
// export const bioAuthCallback = (val, data) => {
//   //val(인증값) = 1:인증성공,2:인증등록성공(안드로이드용),0:인증실패
//   alert(val); //넘어온 인증값 확인
//   if (val === 1) {
//     alert(JSON.stringify(data)); //생체인증으로 저장된 값 확인(인증성공시에만 넘어옴)
//   }
//   //인증값에 따른 로직을 아래에 적용해주시면됩니다.
//   //안드로이드는 등록과정이 있기때문에 등록이후 인증되는 "1"값이 넘어올때가 최종인증으로 보면 됨.
// };
